import {UserRole} from '../../security/model/user-role';
import {axiosReadHelper} from '../../shared/service/axios-read-helper';
import {AxiosReadPayload} from '../../shared/service/axios-read-payload';

class AdminRoleService {

  async getUserRolesFromCache(): Promise<UserRole[]> {

    const readPayload: AxiosReadPayload = {
      url: 'user/v2/roles'
    }

    const response = await axiosReadHelper(readPayload);
    let roleId = 0;

    response.entity.forEach(function (e: any) {
      e.id = roleId + 1;
    });

    const userRoles: UserRole[] = response.entity;

    return userRoles;
  }
}

export const adminRoleService = new AdminRoleService();
